import { Dropdown, DropdownProps, Field, InfoLabel, LabelProps, makeStyles, mergeClasses, OptionOnSelectData, Slot } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React, { PropsWithChildren } from 'react';
import { useCommonStyles } from '../../../common/hooks';


interface Props {
  onOptionSelect: (option: OptionOnSelectData) => void;
  label?: string;
  required?: boolean;
  validationMessage?: Slot<'div'>;
  hintMessage?: Slot<'div'>;
  tooltipText?: string;
  className?: string;
  dropdownProps: Omit<DropdownProps, 'onOptionSelect'>;
  orientation?: 'horizontal' | 'vertical';
}

const useStyles = makeStyles({
  resetWidth: { minWidth: '80px' },
});

const SelectOptionsImpl: React.FC<PropsWithChildren<Props>> =
  props => {
    const {
      onOptionSelect,
      label,
      required,
      validationMessage,
      hintMessage,
      tooltipText,
      className = '',
      dropdownProps,
      children,
      orientation,
    } = props;

    const commonStyles = useCommonStyles();
    const styles = useStyles();

    const renderTooltipLabel = (label: string, tooltipText: string, props: LabelProps) => (
      <InfoLabel
        {...props}
        label={{ className: commonStyles.inputFieldLabel }}
        info={{
          children: tooltipText,
          className: commonStyles.tooltip,
        }}
      >
        {label}
      </InfoLabel>
    );

    return (
      <Field
        orientation={orientation}
        className={mergeClasses('select-option', className)}
        required={required}
        validationMessage={validationMessage}
        validationMessageIcon={null}
        hint={hintMessage}
        label={label ? {
          children: tooltipText ? (_: unknown, props: LabelProps) => renderTooltipLabel(label, tooltipText, props) : label,
          className: commonStyles.inputFieldLabel,
        } : undefined}
      >
        <Dropdown
          {...dropdownProps}
          className={dropdownProps.disabled ? mergeClasses(styles.resetWidth, dropdownProps?.className) : mergeClasses(commonStyles.inputField, dropdownProps?.className)}
          onOptionSelect={(_, data) => onOptionSelect(data)}
        >
          {children}
        </Dropdown>
      </Field>
    )
  };

export const SelectOptions = observer(SelectOptionsImpl);
